module.exports = __webpack_public_path__ + "static/media/line.29c1bf36.jpg";